"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewSupportingDocument = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const text_area_1 = require("client/components/material/text-area");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const core_1 = require("@material-ui/core");
const store_2 = require("client/modules/asset-approvals/store");
const moment = require("moment");
const styles = (theme) => core_1.createStyles({
    activeDocument: {
        color: "green"
    },
    approved: {
        color: "green"
    },
    changes: {},
    detail: {
        paddingLeft: "1rem"
    },
    details: {
        "& > div": {
            marginBottom: "2rem"
        },
        "display": "flex",
        "flexDirection": "column"
    },
    document: {
        "&:hover": {
            color: "blue",
            cursor: "pointer"
        }
    },
    documents: {},
    rejected: {
        color: "red"
    },
    status: {}
});
let ReviewSupportingDocumentUnstyled = class ReviewSupportingDocumentUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.rejectionReason = "";
        this.assetModal = false;
        this.showConfirmationReject = false;
        this.handleDocumentClick = (sd) => () => {
            this.currentSupportingDocumentViewing = sd;
        };
        this.renderModalConfirmRejection = () => this.showConfirmationReject && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm Rejection", cancelText: "Cancel", message: "Are you sure you want to reject this change request? <br /><br />To proceed, please provide a rejection reason below.<br />", addinModal: React.createElement(text_area_1.MaterialTextArea, { className: "notes", onChange: this.handleChangeRejectionReason, placeholder: "Rejection Reason", value: this.rejectionReason }), onCancel: () => {
                this.showConfirmationReject = false;
            }, onConfirm: this.handleReject, title: "Confirm Rejection" }));
        this.handleSubmit = () => {
            callable_1.callable(this.props.onSave)(this.props.asset, "approve");
        };
        this.handleConfirmReject = () => {
            this.showConfirmationReject = !this.showConfirmationReject;
        };
        this.handleReject = () => {
            this.showConfirmationReject = false;
            callable_1.callable(this.props.onSave)(this.props.asset, "reject", this.rejectionReason);
            this.rejectionReason = "";
        };
        this.handleChangeRejectionReason = (event, value) => {
            this.rejectionReason = value;
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
    }
    componentDidMount() {
        if (!this.currentSupportingDocumentViewing) {
            const { asset } = this.props;
            const { supportingDocuments } = asset;
            const [supportingDocument] = supportingDocuments;
            this.currentSupportingDocumentViewing = supportingDocument;
        }
    }
    render() {
        const { asset, classes } = this.props;
        const { approver, id, groupName, createdAt, deletedAt, approved, rejected, approvalDate, rejectionDate, siteUpdateMetas, user, userId, site, siteId, supportingDocuments } = asset;
        const approveUser = approver
            ? `${approver.firstName} ${approver.lastName}`
            : "";
        let decisionDate = "";
        try {
            decisionDate = approved
                ? moment(approvalDate).format("M/DD/YYYY")
                : rejected
                    ? moment(rejectionDate).format("M/DD/YYYY")
                    : "";
        }
        catch (err) {
            console.error("Error normalizing decision date", err);
        }
        const canEdit = store_1.usersStore.permissions.ReadAssetApprovals;
        const filePath = this.currentSupportingDocumentViewing
            ? this.currentSupportingDocumentViewing.filePath
            : "";
        const fileOriginalName = this.currentSupportingDocumentViewing
            ? this.currentSupportingDocumentViewing.fileOriginalName
            : "";
        const isCsv = (filePath === null || filePath === void 0 ? void 0 : filePath.includes(".csv")) && !filePath.includes(".txt");
        const shouldDisableButtons = !!approved || !!rejected;
        return (React.createElement("div", { className: "review-asset" },
            React.createElement("a", { className: "close-button", onClick: this.handleCancel },
                React.createElement(icons_1.CloseIcon, null)),
            React.createElement("div", { className: "main" },
                React.createElement("div", { className: "main-left" },
                    React.createElement(material_ui_1.Typography, { align: "center", variant: "title" }, fileOriginalName || ""),
                    React.createElement("div", { className: "iframe-container" }, isCsv ? (React.createElement("div", null,
                        React.createElement(material_ui_1.Typography, { align: "center", variant: "title" }, "Preview of csv file format is not available. To view file, click on the Download button below."))) : filePath ? (React.createElement("iframe", { title: "document", className: "iframe", src: filePath })) : null),
                    React.createElement("div", { className: "ui-form__buttons" }, filePath && fileOriginalName ? (React.createElement("a", { href: filePath, download: fileOriginalName },
                        React.createElement(button_1.MaterialButton, { flat: true }, "Download"))) : null)),
                React.createElement("div", { className: "asset-info" },
                    React.createElement(ui_1.UiForm, { buttons: canEdit && !this.props.rejected
                            ? [
                                React.createElement(button_1.MaterialButton, { key: "cancel", className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                                React.createElement(button_1.MaterialButton, { disabled: shouldDisableButtons, key: "reject", className: "btnReject", onClick: this.handleConfirmReject }, "Reject"),
                                "Approve"
                            ]
                            : [
                                React.createElement(button_1.MaterialButton, { key: "cancel", className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                                "Approve"
                            ], shouldDisableSave: shouldDisableButtons, onSubmit: this.handleSubmit, loading: store_2.assetApprovalsStore.supportingDocuments.loading, saved: "Saved", error: this.props.error },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: classes.details },
                                React.createElement("div", null,
                                    React.createElement(material_ui_1.Typography, { variant: "subheading" }, "Request Status"),
                                    React.createElement("div", { className: classes.detail },
                                        React.createElement(material_ui_1.Typography, { className: approved
                                                ? classes.status
                                                : rejected
                                                    ? classes.rejected
                                                    : "" }, approved
                                            ? `Approved by ${approveUser} on ${decisionDate}`
                                            : rejected
                                                ? `Rejected by ${approveUser} on ${decisionDate}`
                                                : "Pending Approval"))),
                                React.createElement("div", { className: classes.documents },
                                    React.createElement(material_ui_1.Typography, { variant: "subheading" }, "Supporting Documents"),
                                    React.createElement("div", { className: classes.detail }, supportingDocuments.map(sd => {
                                        const currentlyViewing = this.currentSupportingDocumentViewing &&
                                            this.currentSupportingDocumentViewing.id === sd.id;
                                        return (React.createElement(material_ui_1.Typography, { key: sd.id, onClick: this.handleDocumentClick(sd), className: `${classes.document}${currentlyViewing
                                                ? ` ${classes.activeDocument}`
                                                : ""}` }, `${sd.fileOriginalName}${currentlyViewing ? " (Curently viewing)" : ""}`));
                                    }))),
                                React.createElement("div", { className: classes.changes },
                                    React.createElement(material_ui_1.Typography, { variant: "subheading" }, "Update Requested"),
                                    React.createElement("div", { className: classes.detail }, siteUpdateMetas.map(sum => {
                                        const [fieldName, fromTo] = sum;
                                        return (React.createElement(material_ui_1.Typography, { key: fieldName }, `${fieldName}: ${fromTo.from} --> ${fromTo.to}`));
                                    })))))))),
            this.showConfirmationReject && this.renderModalConfirmRejection(),
            React.createElement(ReactTooltip, { effect: "solid", place: "right", delayShow: 300, "data-type": "info", multiline: true })));
    }
};
__decorate([
    mobx_1.observable
], ReviewSupportingDocumentUnstyled.prototype, "key", void 0);
__decorate([
    mobx_1.observable
], ReviewSupportingDocumentUnstyled.prototype, "currentSupportingDocumentViewing", void 0);
__decorate([
    mobx_1.observable
], ReviewSupportingDocumentUnstyled.prototype, "rejectionReason", void 0);
__decorate([
    mobx_1.observable
], ReviewSupportingDocumentUnstyled.prototype, "assetModal", void 0);
__decorate([
    mobx_1.observable
], ReviewSupportingDocumentUnstyled.prototype, "showConfirmationReject", void 0);
ReviewSupportingDocumentUnstyled = __decorate([
    mobx_react_1.observer
], ReviewSupportingDocumentUnstyled);
exports.ReviewSupportingDocument = core_1.withStyles(styles)(ReviewSupportingDocumentUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/asset-approvals/components/review-supporting-document/review-supporting-document.tsx
// module id = 3264
// module chunks = 0